module.exports = __webpack_public_path__ + "distribution/img/tou.362566b2.png";